import React, { PureComponent } from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import container from './container'
import { styles, translations } from 'gipsy-misc'
import Line from 'features/list/components/line'
import { media } from 'gipsy-ui'
import TaskPanel from 'features/taskPanel'
import { getSrc } from 'utils/image'

const propTypes = {
  todayList: PropTypes.array,
  onComplete: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired
}

export class FocusView extends PureComponent {
  renderFocusModeWithItem = itemToDisplay => {
    const { onClick, onComplete, onChange } = this.props
    return (
      <FilledFocusViewContainer className="focus-view-container">
        <TitleContainer>{translations.focusView.title}</TitleContainer>
        <LineContainer>
          <Line
            hideDraggableCell={true}
            item={itemToDisplay}
            onComplete={onComplete}
            onClick={onClick}
            onChange={onChange}
          />
        </LineContainer>
        <TaskPanel />
      </FilledFocusViewContainer>
    )
  }

  renderFocusModeWithoutItem = () => {
    return (
      <EmptyFocusViewContainer>
        <Logo className="logo" src={getSrc('/images/gipsybot_relax.svg')} alt="logo" />
        <SubtitleContainer>{translations.focusView.emptyContent}</SubtitleContainer>
      </EmptyFocusViewContainer>
    )
  }

  render = () => {
    const { todayList } = this.props
    let itemToDisplay
    if (todayList.length > 0) {
      itemToDisplay = todayList[0]
    }

    return (
      <FocusViewContainer className="focus-view-container">
        {itemToDisplay ? this.renderFocusModeWithItem(itemToDisplay) : this.renderFocusModeWithoutItem()}
      </FocusViewContainer>
    )
  }
}

const FocusViewContainer = styled.div`
  width: 100%;
  height: 100%;
  padding-top: 20%;
  ${media['phone-wide']`
    padding-left: 10px;
    padding-right: 10px;
  `}
`

const FilledFocusViewContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
`

const TitleContainer = styled.div`
  font: ${styles.fonts.primaryFont};
  font-size: 38px;
  font-weight: 500;
  color: ${styles.colors.textDarkColor};
  margin-bottom: 30px;
`

const LineContainer = styled.div`
  min-height: 120px;
  border-radius: 24px;
  background-color: #ffffff;
  box-shadow: 0 16px 48px 0 rgba(235, 234, 238, 0.48);
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 30px;
`

const EmptyFocusViewContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`

const Logo = styled.img`
  height: 120px;
  width: 160px;
  margin-bottom: ${styles.spacings.normal};
  ${media['phone-wide']`
    margin-top: 20px;
  `}
`

const SubtitleContainer = styled.div`
  font: ${styles.fonts.primaryFont};
  font-size: 20px;
  font-weight: 400;
  color: ${styles.colors.textRegularColor};
`

FocusView.propTypes = propTypes

export default container(FocusView)



// WEBPACK FOOTER //
// ./src/pages/focusview/index.js